import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
  GridPreProcessEditCellProps,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
// import axios from "axios";

import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Button, MenuItem, Select, TextField, Typography } from "@mui/material";
import CustomPagination from "../../../component/common/CustomPagination";
import { koKRGrid } from "../../../component/common/TableKRText";
import api from "../../../../API";
// import MemberDetailDiaglog from  "./MemberDetailDialog";
import { useSelector } from "react-redux";
import { SearchBackDrop } from "../../../component/common/SearchBackDrop";
// import { getCodeNm } from "../../component/common/CodeNm";

function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function validatephone(phone: string) {
  const re = /^\(?(\d{3})\)?[- ]?(\d{4})[- ]?(\d{4})$/;
  return re.test(String(phone).toLowerCase());
}

function CustomToolbar(props: any) {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
        }}
      />
      <Box display="flex" sx={{marginLeft: "auto", alignItems: "center"}}>

        <Box>
          <Box sx={{fontWeight:700, marginLeft:"8px", color:"#2f9c34"}}>총 건수 :{props.totalCount ? props.totalCount : "0"} 건</Box>
          <Box sx={{fontWeight:700, marginLeft:"8px", color:"#000"}}>선택 :{props.selectCheckCnt ? props.selectCheckCnt : "0"} 개</Box>
        </Box>

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>정렬</Box>
        <Select id="order" value={props.order} onChange={(e)=>props.setOrder(e.target.value)} sx={{width:"100px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"asc"}>처음</MenuItem>
          <MenuItem dense value={"desc"}>최신</MenuItem>
        </Select>

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>시작일</Box>
        <TextField sx={{marginLeft: "8px",fontSize:"8px"}} id="job_start_date" name="job_start_date" size="small" type="date"
                  value={props.jobStartDate} onChange={(e)=>props.setJobStartDate(e.target.value)}
        // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
          InputProps={{
            style: {width: "150px", height:"30px", fontSize:"14px"},
            inputProps: { 
              spellCheck: "false" // spellcheck를 false로 설정
            },
          }}
        />

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>종료일</Box>
        <TextField sx={{marginLeft: "8px",fontSize:"8px"}} id="job_end_date" name="job_end_date" size="small" type="date"
                  value={props.jobEndDate} onChange={(e)=>props.setJobEndDate(e.target.value)}
        // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
          InputProps={{
            style: {width: "150px", height:"30px", fontSize:"14px"},
            inputProps: { 
              spellCheck: "false" // spellcheck를 false로 설정
            },
          }}
        />
        

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>작업구분</Box>
        <Select id="roleParam" value={props.roleParam} onChange={(e)=>props.setRoleParam(e.target.value)} sx={{width:"134px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          <MenuItem dense value={"수집"}>수집</MenuItem>
          <MenuItem dense value={"정제/가공"}>정제/가공</MenuItem>
          <MenuItem dense value={"검수"}>검수</MenuItem>
        </Select>
        {/* <Select
          labelId="demo-simple-select-label"
          id="role" 
          name="role"
          value={props.roleParam}
          label="권한"
          sx={{width:"150px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}
          onChange={(e)=>props.setRoleParam(e.target.value)}
        >
          <MenuItem dense value={"모두"}>모두</MenuItem>
          {props.auths.length !== 0 ? (
            props.auths.map((auth: any, index:number) => {
              return (
                <MenuItem key={auth.code} dense value={auth.code}>{auth.code_nm}</MenuItem>
              );
            })
          ) : ""}
        </Select> */}

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>작업ACT</Box>
        <TextField size="small" id="job_act" value={props.job_act} onChange={(e)=>props.setJob_act(e.target.value)} sx={{width:"150px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} />

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>이름</Box>
        <TextField size="small" id="worker" value={props.worker} onChange={(e)=>props.setWorker(e.target.value)} sx={{width:"90px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} />
        <Button variant="contained" sx={{marginLeft:"8px"}} onClick={()=>{props.setWorkerParam();}}>검색</Button>
      </Box>
      <GridToolbarQuickFilter sx={{ marginLeft: "16px" }} />
    </GridToolbarContainer>
  );
}










const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

export interface roleType {
  role: string;
  user_id: string;
  type: string;
  use_yn: string;
}

export interface rowDetailType {
  id: number;
  email: string;
  name: string;
  birth: string;
  gender: string;
  jumin: string;
  bank: string;
  bank_num: string;
  phone: string;
  startDate: string;
  roles: roleType[];
}

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const VieWorkLog = () => {

  const [auths, setAuths] = useState([]);

  const store = useSelector((state:any)=> state)

  // console.log('store',store)

  const authCodeList = useSelector((state:any)=> state.code.auth.data)
  const getCodeNm = (role:string) =>{
    
    if(role === "ADMIN"){
      return "관리자"
    }
    else if(authCodeList){
      // console.log('authCodeList',authCodeList,role)

      // authCodeList.find((authCode:any)=> authCode.code === role)

      const find_role = authCodeList.find((authCode:any)=> authCode.code === role)

      // console.log('find_role',find_role)

      if(find_role){
        return find_role.code_nm.toString()
      }else{
        return ""
      }
    }
  }

  const getAuths = async () => {
    var result = await api.get("/getAuths");

    setAuths(result.data.data);
    
  };

  const columns: GridColDef[] = [
    { field: "id", headerName: "id", headerAlign: "center", width: 90,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>ID</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{width: 90,fontWeight:600,display:"flex",justifyContent: "center", fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    {
      field: "user_name", headerName: "이름", headerAlign: "center", headerClassName: "header-style", width: 200,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>이름</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{width: 200,fontWeight:600,display:"flex",justifyContent: "center", fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "job_gbn", headerName: "작업구분", headerAlign: "center", width: 130, type: "date",
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>작업구분</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{width:"130px",fontWeight:600,display:"flex",justifyContent: "center", fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "job_act", headerName: "작업ACT", headerAlign: "center", width: 130, type: "date",
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>작업ACT</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{width:"130px",fontWeight:600,display:"flex",justifyContent: "center", fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "job_start_date", headerName: "ins_date", headerAlign: "center", width: 300,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>작업시작일</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{width:"300px",fontWeight:600,display:"flex",justifyContent: "center", fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "job_end_date", headerName: "ins_date", headerAlign: "center", width: 300,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>작업종료일</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{width:"300px",fontWeight:600,display:"flex",justifyContent: "center", fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "ins_date", headerName: "ins_date", headerAlign: "center", width: 300,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>ins_date</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{width:"300px",fontWeight:600,display:"flex",justifyContent: "center", fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    // { field: "roles", headerName: "권한", headerAlign: "center", width: 400,
    //   renderHeader: (params: any) => (
    //     <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>권한</Box>
    //   ),
    //   valueGetter: (params: any) => {
    //     // console.log('valueGetter' , params.value)
    //     const work_role = params.value.filter((role:any) => role.role === 'ADMIN' || role.use_yn === "sample_confirm");
    //     // console.log('work_role',work_role)
    //     // const work_role = params.value.filter((role:any) => role.use_yn === 'Completed');

    //     // const role_code_nm = work_role.map((wr:any) => getCodeNm(wr.role))
    //     const role_code_nm = params.value.map((wr:any) => {if(["VIE","VIE_MANAGER","KHM","TZA"].includes(wr.role)){return (getCodeNm(wr.role) + " ( "+ wr.user_id.replace('undefined','-') + " ) ")} else{ return (getCodeNm(wr.role))}})
    //     // console.log('role_code_nm',role_code_nm)
  
    //     return role_code_nm.toString();
    //   },
    //   valueSetter: (params: any) => {
    //     // console.log('valueSetter' , params.value)
    //     const work_role = params.value.filter((role:any) => role.role === 'ADMIN');
    //     // console.log('work_role',work_role)
    //     return work_role.toString()
    //     // const work_role = params.value.filter((role:any) => role.use_yn === 'Completed');
    //     // const role_code_nm = work_role.map((wr:any) => getCodeNm(wr.role))
    //     // console.log('role_code_nm',role_code_nm)
  
    //     // return role_code_nm.toString();
    //   },
    //   valueParser: (params: any) => {
    //     console.log('valueParser' , params)
    //     // const work_role = params.value.filter((role:any) => role.use_yn === 'Completed');
    //     // const role_code_nm = work_role.map((wr:any) => getCodeNm(wr.role))
    //     // console.log('role_code_nm',role_code_nm)
  
    //     // return role_code_nm.toString();
    //   },
    //   // renderCell: (params:any) => (
    //   //     <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
    //   // )
    // },
  ];
  
  

  // console.log('get Code Nm' , getCodeNm('NKI'))

  const [page, setPage] = useState(1);

  const [totalCount, setTotalCount] = useState(0);
  const [selectCheckCnt , setSelectCheckCnt] = useState(0)

  const handleSelectionModelChange = (ids:any) => {
    setSelectCheckCnt(ids.length)
  };

  const [roleParam, setRoleParam] = useState('모두');
  const [order, setOrder] = useState('desc');
  const [worker, setWorker] = useState('');
  const [job_act, setJob_act] = useState('');

  const [jobStartDate, setJobStartDate] = useState('');
  const [jobEndDate, setJobEndDate] = useState('');

  const [p_worker, setP_worker] = useState('');
  const [p_job_act, setP_job_act] = useState('');
  const [p_jobStartDate, setP_jobStartDate] = useState('');
  const [p_jobEndDate, setP_jobEndDate] = useState('');

  const setWorkerParam = () => {
    setP_worker(worker);
    setP_job_act(job_act);
    setP_jobStartDate(jobStartDate);
    setP_jobEndDate(jobEndDate);
  }

  const [rows, setRows] = useState([]);
  const [rowDetail, setRowDetail] = useState<rowDetailType>({
    id: 0,
    email: "",
    name: "",
    birth: "",
    gender: "",
    jumin: "",
    bank: "",
    bank_num: "",
    phone: "",
    startDate: "",
    roles: [{role:"",user_id:"",type:"",use_yn:""}],
  });
  // api 사용자 정보에서 페이지 정보를 담을 state
  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );

  // 팝업 관리 state
  const [dialogOpen, setDialogOpen] = useState(false);

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const getMemberList = async (roleParam:any) => {
    if(roleParam == undefined){
      roleParam = ''
    }
    setBackdrop(true)
    var result = await api.get("/vieWorkLogList",{params:{email:email,page:page,roleParam:roleParam,order:order,worker:p_worker,job_act:p_job_act,jobStartDate:p_jobStartDate,jobEndDate:p_jobEndDate}});
    // console.log("result.data", result.data);
    setBackdrop(false)
    console.log('VIE' , datas)
    var datas = result.data.datas.map((data: any, idx: any) => {
      return {
        id: idx + 1,
        idx: data.idx,
        user_name: data.user_name,
        job_gbn: data.job_gbn,
        job_act: data.job_act,
        job_start_date: data.job_start_date,
        job_end_date: data.job_end_date,
        ins_date: data.ins_date,

      };
    });

    // table에 넣을 rows 데이터 state에 저장
    setRows(datas);
    // pagination에 넣을 api data 페이지 정보를 state에 저장
    setPagination(result.data.pagination);
    setTotalCount(result.data.pagination.total_count);
    // console.log("data", result.data.datas);
  };

  useEffect(() => {
    getAuths();
    getMemberList(roleParam);
  }, [roleParam,page,order,p_worker,p_job_act,p_jobStartDate,p_jobEndDate]);

  const goDetail = (data: any) => {
    // console.log("goDetail", data);
    setRowDetail(data);
    setDialogOpen(true);
  };

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  function CustomFooter() {
    // console.log("CustomFooter pagination", pagination);
    return (
      <GridFooterContainer sx={{ display: "flex", justifyContent: "center" }}>
        {pagination !== undefined ? (
          <CustomPagination pagination={pagination} goPage={goPage} />
        ) : ""}
      </GridFooterContainer>
    );
  }

  const [backdrop, setBackdrop] = useState<boolean>(false)

  return (
    <Box
      sx={{
        width: "100%",
        "& .MuiDataGrid-cell--editing": {
          bgcolor: "rgb(255,215,115, 0.19)",
          color: "#1a3e72",
          "& .MuiInputBase-root": {
            height: "100%",
          },
        },
        "& .Mui-error": {
          bgcolor: (theme) =>
            `rgb(126,10,15, ${theme.palette.mode === "dark" ? 0 : 0.1})`,
          color: (theme) =>
            theme.palette.mode === "dark" ? "#ff4343" : "#750f0f",
        },
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-cell--textLeft": {justifyContent : "center"},
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-columnHeader--sortable": {padding : "16px"}
        // ".header-style":{
        //   backgroundColor: "#95b1d1",
        //   fontWeight: 600,
        //   color: "#fff"
        // }
      }}
    >
      <ThemeProvider theme={theme}>
        <Box sx={{ width: "100%", marginLeft:"8px" }}><h3>VIE Work Log 확인</h3></Box>
        <Box sx={{ height: "600px", width: "100%",position:"relative" }}>
          {backdrop && ( <SearchBackDrop/> )}
          <DataGrid
            editMode="row"
            rows={rows}
            columns={columns}
            onRowDoubleClick={(e) => goDetail(e.row)}
            checkboxSelection
            onSelectionModelChange={handleSelectionModelChange}
            pageSize={100}
            components={{ Toolbar: CustomToolbar, Footer: CustomFooter}}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
                roleParam: roleParam,
                setRoleParam: setRoleParam,
                jobStartDate: jobStartDate,
                setJobStartDate: setJobStartDate,
                jobEndDate: jobEndDate,
                setJobEndDate: setJobEndDate,
                auths: auths,

                totalCount:totalCount,
                selectCheckCnt: selectCheckCnt,

                order: order,
                setOrder: setOrder,

                worker: worker,
                setWorker: setWorker,
                setWorkerParam: setWorkerParam,

                job_act: job_act,
                setJob_act: setJob_act,


              },
            }}
            getRowId={(row) => row.idx}
            localeText={koKRGrid}
            experimentalFeatures={{ newEditingApi: true }}
            // sx={{"&.MuiDataGrid-cell--textLeft": {justifyContent : "center"}}}
          />
        </Box>
      </ThemeProvider>
      {/* <MemberDetailDiaglog setDialogOpen={setDialogOpen} rowDetail={rowDetail} setRowDetail={setRowDetail} getMemberList={getMemberList} />
      {dialogOpen ? <MemberDetailDiaglog memberInfo={rowDetail} /> : <></>} */}
      {/* {dialogOpen == true ? (
        <MemberDetailDiaglog
          // dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          rowDetail={rowDetail}
          setRowDetail={setRowDetail}
          getMemberList={getMemberList}
          />
          ) : ""} */}
        </Box>
      );
    };
export default VieWorkLog;
